<template>
  <span :id="containerId" :ref="containerId">
    <button type="button"
            :class="buttonClass"
            ref="copyButton"
            v-clipboard:copy="this.value"
            v-clipboard:success="onCopy">
      <icon class="btn-icon" name="copy" scale="1.0"/>
      {{ this.title || "" }}
    </button>
    <b-tooltip :target="() => $refs.copyButton"
                       :container="containerId"
                       placement="bottom"
                       :delay="{show: 400}"
                       @hidden="tooltipHidden">
      {{tooltipTitle}}
    </b-tooltip>
  </span>
</template>

<script>
  import 'vue-awesome/icons/copy'

  const TOOLTIP_TITLES = {
    NOT_COPIED: 'Copy to clipboard',
    COPIED: 'Copied!'
  }
  export default {

    props: {
      small: {
        type: Boolean
      },
      value: {
        type: String,
        required: true
      },
      title: {
        type: String
      }
    },

    data() {
      return {
        tooltipTitle: TOOLTIP_TITLES.NOT_COPIED,
        containerId: `copy-button-container-${Math.floor(Math.random() * (1000000))}` // hack for random id
      }
    },

    computed: {
      buttonClass() {
        const base = 'btn'
        const small = this.small ? 'btn-sm' : ''
        if (this.title) {
          return `${base} ${small} btn-outline-primary`
        }
        return `${base} ${small} btn-link`
      }
    },

    methods: {
      onCopy() {
        // hack to make copy button work in modals in Chrome
        // https://github.com/Inndy/vue-clipboard2#it-doesnt-work-with-bootstrap-modals
        // without this hack the copy button kinda works, but has to be pressed twice to actually copy the value
        const container = this.$refs[this.containerId]
        this.$copyText(this.value, container)

        this.tooltipTitle = TOOLTIP_TITLES.COPIED
        this.$emit('onSuccess')
      },

      tooltipHidden() {
        this.tooltipTitle = TOOLTIP_TITLES.NOT_COPIED
      }
    }
  }
</script>
